import { render, staticRenderFns } from "./ModelGeneratorDetail.vue?vue&type=template&id=3c49003a&scoped=true&"
import script from "./ModelGeneratorDetail.vue?vue&type=script&lang=js&"
export * from "./ModelGeneratorDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModelGeneratorDetail.vue?vue&type=style&index=0&id=3c49003a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49003a",
  null
  
)

export default component.exports